module.exports = __webpack_public_path__ + "img/7.d1cd8d6b.png";